import "./FaixaAmbiente.css";

/**
 * A faixa que diz onde a pessoa está.
 *
 * <p><b>Isto é controle regulatório, não decoração.</b> O
 * `plantus.redearkadia.com.br` recebe **dado real desde cedo** e roda em
 * paralelo ao processo atual — mas **não é sistema validado nem o
 * registro oficial**. Um sistema não validado precisa ser
 * inequivocamente distinguível de um validado
 * (ADR-0004 §"Impacto regulatório").
 *
 * <p>O texto importa e foi escolhido: ele **não** diz "demonstração". O
 * sistema recebe dado de verdade; chamá-lo de demonstração seria
 * impreciso na direção errada — quem lesse concluiria que o conteúdo é
 * fictício. O que ele diz é o que de fato vale: não substitui o registro
 * oficial.
 *
 * <p>Só `producao` esconde a faixa. Ambiente **desconhecido** a exibe —
 * na dúvida, avisa. Errar essa variável faz um ambiente não validado se
 * passar por validado, e o padrão silencioso precisa cair para o lado
 * seguro.
 */

interface Props {
  /** Vem de `GET /api/versao`. */
  ambiente: string | null;
}

const TEXTO: Record<string, { rotulo: string; detalhe: string }> = {
  desenvolvimento: {
    rotulo: "Desenvolvimento",
    detalhe: "Massa de teste. Nada aqui é registro oficial.",
  },
  homologacao: {
    rotulo: "Homologação",
    detalhe: "Massa de teste. Nada aqui é registro oficial.",
  },
  operacao_assistida: {
    rotulo: "Operação assistida",
    detalhe:
      "Sistema NÃO VALIDADO. Não substitui o registro oficial — o processo atual continua valendo.",
  },
  desconhecido: {
    rotulo: "Ambiente não identificado",
    detalhe: "Trate como NÃO VALIDADO até que se confirme o contrário.",
  },
};

export function FaixaAmbiente({ ambiente }: Props) {
  if (ambiente === "producao") {
    return null;
  }

  const chave = ambiente !== null && ambiente in TEXTO ? ambiente : "desconhecido";
  const { rotulo, detalhe } = TEXTO[chave]!;

  return (
    <div className="ui-faixa" role="note">
      <strong className="ui-faixa__rotulo">{rotulo}</strong>
      <span className="ui-faixa__detalhe">{detalhe}</span>
    </div>
  );
}
